import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const PaymentRefund = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Payment & Refund Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection text-center wow animate__fadeInDown">
              <h2>HOURLEE - PAYMENT AND REFUND POLICY</h2>
            </div>

            <h3>
              <strong>RightO Services Private Ltd.</strong>
            </h3>
            <p>
              <strong>Effective Date:</strong> 07 January 2026
              <br /> <strong>Last Updated:</strong>&nbsp; 07 January 2026
            </p>
            <p>
              This Payment, Cancellation &amp; Refund Policy (&ldquo;
              <strong>Policy</strong>&rdquo;) governs all payments,
              cancellations, refunds, and financial transactions between{" "}
              <strong>Employers</strong>, <strong>Job Seekers</strong>, and{" "}
              <strong>RightO Services Private Ltd.</strong>, operating under the
              brand name <strong>Hourlee</strong> (&ldquo;
              <strong>Platform</strong>&rdquo;, &ldquo;<strong>we</strong>
              &rdquo;, &ldquo;<strong>us</strong>&rdquo;, &ldquo;
              <strong>our</strong>&rdquo;).
            </p>
            <p>
              By using Hourlee, you agree to be bound by this Policy, the Terms
              &amp; Conditions, and all applicable laws, including:
            </p>
            <ul>
              <li>
                Indian Contract Act, 1872
                <br />{" "}
              </li>
              <li>
                Payment &amp; Settlement Systems Act, 2007
                <br />{" "}
              </li>
              <li>
                Income Tax Act, 1961
                <br />{" "}
              </li>
              <li>
                Goods and Services Tax (GST) Act, 2017
                <br />{" "}
              </li>
              <li>
                Information Technology Act, 2000
                <br />{" "}
              </li>
              <li>
                Arbitration &amp; Conciliation Act, 1996
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>1. Scope of This Policy</strong>
            </h3>
            <p>This Policy applies to:</p>
            <ul>
              <li>
                <strong>Employers</strong> who post and pay for hourly or
                project-based work.
                <br />{" "}
              </li>
              <li>
                <strong>Job Seekers</strong> who accept and perform jobs through
                Hourlee.
                <br />{" "}
              </li>
              <li>
                All{" "}
                <strong>
                  payments and refunds are initiated through the
                  Platform&rsquo;s secure payment gateway/escrow system
                </strong>
                .<br />{" "}
              </li>
            </ul>
            <p>
              Off-platform payments are <strong>strictly prohibited</strong> and
              may result in suspension or termination of user accounts.
            </p>
            <h3>
              <strong>2. Mandatory On-Platform Payments</strong>
            </h3>
            <p>
              2.1 All payments between Employers and Job Seekers must be
              processed exclusively through the Platform&rsquo;s secure payment
              system.
              <br /> &nbsp;
            </p>
            <p>
              2.2 Direct cash payments, UPI transfers, bank transfers, or any
              off-platform transactions are strictly prohibited.
              <br /> &nbsp;
            </p>
            <p>2.3 Any user found bypassing the payment system may face:</p>
            <ul>
              <li>
                Account suspension or permanent termination
                <br />{" "}
              </li>
              <li>
                Loss of access to Platform services
                <br />{" "}
              </li>
              <li>
                Withholding of payments
                <br />{" "}
              </li>
              <li>
                Legal action where required
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3. Escrow &amp; Wallet System</strong>
            </h3>
            <p>
              To ensure transparent and secure transactions, Hourlee uses an{" "}
              <strong>escrow-based wallet system</strong>:
            </p>
            <h3>
              <strong>3.1 Employer Deposits</strong>
            </h3>
            <ul>
              <li>
                Employers must deposit the{" "}
                <strong>full job amount upfront</strong> into the Hourlee escrow
                wallet.
                <br />{" "}
              </li>
              <li>
                Funds remain in escrow until job completion is confirmed.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3.2 Fund Release Conditions</strong>
            </h3>
            <p>
              Funds are released when:
              <br /> &nbsp;a) Employer confirms that the work is completed
              satisfactorily,{" "}
              <strong>
                or
                <br />{" "}
              </strong>
              &nbsp;b) Employer does not respond within the{" "}
              <strong>48-hour confirmation window</strong>, after which payment
              is auto-approved.
            </p>
            <h3>
              <strong>3.3 Escrow Hold During Disputes</strong>
            </h3>
            <ul>
              <li>
                If either party raises a dispute, funds are held in escrow until
                resolved through Hourlee&rsquo;s dispute process.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>4. Service Fees, Taxes &amp; Deductions</strong>
            </h3>
            <h3>
              <strong>4.1 Service Fees</strong>
            </h3>
            <p>
              Hourlee charges a{" "}
              <strong>platform service/transaction fee</strong> to Employers
              and/or Job Seekers.
              <br /> &nbsp;Fees are displayed at the time of job posting or
              acceptance.
            </p>
            <h3>
              <strong>4.2 GST</strong>
            </h3>
            <ul>
              <li>
                Service fees are <strong>exclusive of GST</strong>.<br />{" "}
              </li>
              <li>
                GST is charged at prevailing rates (currently 18%).
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>4.3 TDS</strong>
            </h3>
            <ul>
              <li>
                TDS may be deducted as per the Income Tax Act, 1961.
                <br />{" "}
              </li>
              <li>
                Users must provide valid <strong>PAN</strong> details for
                compliance.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>4.4 Non-Refundable Charges</strong>
            </h3>
            <p>Unless otherwise stated:</p>
            <ul>
              <li>
                Service fees
                <br />{" "}
              </li>
              <li>
                Convenience charges
                <br />{" "}
              </li>
              <li>
                Payment gateway fees{" "}
                <strong>
                  are non-refundable.
                  <br /> <br />{" "}
                </strong>
              </li>
            </ul>
            <h3>
              <strong>5. Payouts to Job Seekers</strong>
            </h3>
            <h3>
              <strong>5.1 Payout Timelines</strong>
            </h3>
            <ul>
              <li>
                Payouts are processed within <strong>T+3 working days</strong>{" "}
                after Employer approval(excluding weekends and bank holidays).
                <br />{" "}
              </li>
              <li>
                &ldquo;T&rdquo; refers to the date of job completion
                confirmation.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>5.2 Payment Methods</strong>
            </h3>
            <p>Payments are made through:</p>
            <ul>
              <li>
                Bank transfer
                <br />{" "}
              </li>
              <li>
                UPI
                <br />{" "}
              </li>
              <li>
                Other supported payout channels
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>5.3 Verification Requirements</strong>
            </h3>
            <p>Job Seekers must provide:</p>
            <ul>
              <li>
                Valid PAN
                <br />{" "}
              </li>
              <li>
                Aadhaar
                <br />{" "}
              </li>
              <li>
                Bank account details
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>5.4 Payment Holds</strong>
            </h3>
            <p>We may temporarily withhold or delay payments if:</p>
            <ul>
              <li>
                Fraud or misrepresentation is suspected
                <br />{" "}
              </li>
              <li>
                Job Seeker violates Platform terms.
                <br />{" "}
              </li>
              <li>
                Regulatory requirements mandate verification
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>6. Employer Cancellations</strong>
            </h3>
            <h3>
              <strong>6.1 Before Job Acceptance</strong>
            </h3>
            <ul>
              <li>
                Employer receives a <strong>full refund</strong>, excluding
                payment gateway charges.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>6.2 After Job Acceptance But Before Work Starts</strong>
            </h3>
            <p>
              Refund ={" "}
              <strong>
                Job Amount - Portal Service Fee - GST - Payment Gateway Charges
              </strong>
            </p>
            <h3>
              <strong>6.3 After Work Has Started</strong>
            </h3>
            <p>
              Refund becomes <strong>proportional</strong>, based on:
            </p>
            <ul>
              <li>
                Actual hours worked
                <br />{" "}
              </li>
              <li>
                Work logs recorded on the Platform
                <br />{" "}
              </li>
            </ul>
            <p>Employer must pay the Job Seeker for work already completed.</p>
            <h3>
              <strong>7. Job Seeker Cancellations</strong>
            </h3>
            <h3>
              <strong>7.1 Before Job Start</strong>
            </h3>
            <ul>
              <li>
                Job Seeker may cancel without penalty.
                <br />{" "}
              </li>
              <li>
                No payout is made.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>7.2 After Job Start</strong>
            </h3>
            <ul>
              <li>
                Job Seeker is paid only for hours already worked.
                <br />{" "}
              </li>
              <li>
                Employer is refunded for unworked hours.
                <br />{" "}
              </li>
              <li>
                Repeated cancellations may lead to suspension.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>8. Refund Conditions for Employers</strong>
            </h3>
            <p>Refunds may be granted in the following situations:</p>
            <h3>
              <strong>8.1 Job Cancelled Before Start</strong>
            </h3>
            <p>Refund minus service fees and GST.</p>
            <h3>
              <strong>8.2 Job Seeker No-Show</strong>
            </h3>
            <p>
              Up to <strong>100% refund</strong>, minus service charges.
            </p>
            <h3>
              <strong>8.3 Unsatisfactory or Non-Performance</strong>
            </h3>
            <p>
              Refund determined after a detailed review of employer-submitted
              evidence.
            </p>
            <h3>
              <strong>8.4 Technical Failures</strong>
            </h3>
            <p>Refunds for duplicate charges or failed transactions.</p>
            <h3>
              <strong>8.5 Refund Timeline</strong>
            </h3>
            <p>
              Refunds are processed within <strong>7- 10 business days</strong>{" "}
              to the original payment method.
            </p>
            <h3>
              <strong>9. Situations Where Refunds Will NOT Be Provided</strong>
            </h3>
            <p>
              Refunds will <strong>not</strong> be issued if:
            </p>
            <ul>
              <li>
                Work was completed as per the job description
                <br />{" "}
              </li>
              <li>
                Employer approved work, and later changed their mind.
                <br />{" "}
              </li>
              <li>
                Refund request is made <strong>after 15 days</strong> from the
                transaction date.
                <br />{" "}
              </li>
              <li>
                Payment was attempted off-platform
                <br /> The employee did not raise a dispute within the allowed
                time.
                <br />{" "}
              </li>
              <li>
                Either party violated the Terms &amp; Conditions.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>
                10. Dispute Resolution &amp; Evidence Requirements
              </strong>
            </h3>
            <p>If an Employer or Job Seeker raises a dispute:</p>
            <h3>
              <strong>10.1 Escrow Freeze</strong>
            </h3>
            <p>Funds are immediately held until resolution.</p>
            <h3>
              <strong>10.2 Evidence Submission</strong>
            </h3>
            <p>Users must provide evidence such as:</p>
            <ul>
              <li>
                Screenshots
                <br />{" "}
              </li>
              <li>
                Work logs
                <br />{" "}
              </li>
              <li>
                Attendance records
                <br />{" "}
              </li>
              <li>
                Chat history
                <br />{" "}
              </li>
              <li>
                Photos or documents
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>10.3 Resolution Outcomes</strong>
            </h3>
            <p>Hourlee may:</p>
            <ul>
              <li>
                Release full payment to the Job Seeker
                <br />{" "}
              </li>
              <li>
                Provide a full or partial refund to the Employer
                <br />{" "}
              </li>
              <li>
                Split payment proportionally
                <br />{" "}
              </li>
            </ul>
            <p>
              The Platform&rsquo;s decision is{" "}
              <strong>final and binding</strong>.
            </p>
            <h3>
              <strong>10.4 Arbitration</strong>
            </h3>
            <p>
              If disputes remain unresolved, they will be settled under the{" "}
              <strong>Arbitration &amp; Conciliation Act, 1996</strong>, with
              jurisdiction in <strong>New Delhi, India</strong>.
            </p>
            <h3>
              <strong>11. Chargebacks &amp; Fraud Prevention</strong>
            </h3>
            <p>In case of chargebacks:</p>
            <ul>
              <li>
                Hourlee may reverse payouts already made
                <br />{" "}
              </li>
              <li>
                The account may be suspended or terminated.
                <br />{" "}
              </li>
              <li>
                Fraudulent chargebacks may lead to legal action under the IT
                Act, 2000, and IPC.
                <br />{" "}
              </li>
            </ul>
            <p>Fraudulent activities include:</p>
            <ul>
              <li>
                Fake jobs
                <br />{" "}
              </li>
              <li>
                Fake worker profiles
                <br />{" "}
              </li>
              <li>
                Misuse of referral systems
                <br />{" "}
              </li>
              <li>
                Manipulation of hours or work logs
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>12. Currency &amp; Banking Standards</strong>
            </h3>
            <ul>
              <li>
                All Platform transactions are in{" "}
                <strong>
                  Indian Rupees (INR)
                  <br /> <br />{" "}
                </strong>
              </li>
              <li>
                Payments are routed via{" "}
                <strong>
                  RBI-regulated gateways.
                  <br /> <br />{" "}
                </strong>
              </li>
              <li>
                Bank/UPI fees are borne by the respective user.s
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>13. Legal Compliance Obligations</strong>
            </h3>
            <h3>
              <strong>13.1 Employer Responsibilities</strong>
            </h3>
            <p>Employers must comply with:</p>
            <ul>
              <li>
                Minimum Wages Act, 1948
                <br />{" "}
              </li>
              <li>
                Payment of Wages Act, 1936
                <br />{" "}
              </li>
              <li>
                Contract Labour Act, 1970 (if applicable)
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>13.2 Job Seeker Responsibilities</strong>
            </h3>
            <p>Job Seekers must:</p>
            <ul>
              <li>
                Declare income
                <br />{" "}
              </li>
              <li>
                Pay applicable taxes
                <br />{" "}
              </li>
              <li>
                Maintain valid identification documents.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>13.3 Platform Assistance</strong>
            </h3>
            <ul>
              <li>
                Hourlee may provide invoices, statements, and TDS summaries for
                tax compliance.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>14. Changes to This Policy</strong>
            </h3>
            <p>
              We may modify this Policy to reflect legal, operational, or
              business changes.
              <br /> &nbsp;Updates will be posted on the Platform with a revised
              &ldquo;Last Updated&rdquo; date.
            </p>
            <p>
              Continued use of the Platform after an update constitutes
              acceptance.
            </p>
            <h3>
              <strong>15. Contact Us</strong>
            </h3>
            <p>For payment, cancellation, or refund-related support:</p>
            <p>
              <strong>Email:</strong> Contact@hourlee.in
            </p>
            <p>
              <strong>Address:</strong> 52/1 Park Road, Dehradun &ndash; 248001
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PaymentRefund;
